// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dbRt1ZWP{padding:5rem 0 2.5rem}.dbRt1ZWP .KJDcWObs{background-color:transparent;border-color:currentColor;color:inherit;font-size:.75rem}.X\\+Sne2rY{display:flex;flex-direction:column;gap:2rem;margin:0 auto;max-width:var(--content-width);padding:0 var(--padding-x);width:100%}.VRde5Dvm{display:flex;flex-wrap:wrap;gap:2rem 4rem;justify-content:space-between}.aYJDWYUO{align-items:flex-end}.w1bQs93X{display:flex;flex-direction:column;gap:1.5rem}.lyB5SPJI{justify-content:space-between}._0wBQ9mul{align-items:center;display:flex;gap:max(1rem,min(1.67vw,2rem))}.Ics47I-e{height:max(3rem,min(3.13vw,3.75rem));max-height:3.75rem;max-width:8.38rem;-o-object-fit:contain;object-fit:contain;width:auto}._6yqagzpl{display:grid;grid-template-columns:repeat(2,1fr);grid-gap:max(1rem,min(1.25vw,1.5rem)) max(1rem,min(2.5vw,3rem));align-self:flex-start;gap:max(1rem,min(1.25vw,1.5rem)) max(1rem,min(2.5vw,3rem))}.k7DyR\\+Vu{font-size:.88rem;font-weight:600;line-height:1.43}@media(hover:hover){.k7DyR\\+Vu:hover{-webkit-text-decoration:underline;text-decoration:underline}}@media(hover:none){.k7DyR\\+Vu:active{-webkit-text-decoration:underline;text-decoration:underline}}.wDBtmJng{gap:max(.25rem,min(.83vw,1rem))}.JbxNUNsa,.wDBtmJng{align-items:center;display:flex}.JbxNUNsa{font-size:2rem;justify-content:center}.BZD14xKs{font-weight:300}.BZD14xKs,.AwhTQl36{font-size:.75rem;line-height:1.33}.AwhTQl36{-webkit-text-decoration:underline;text-decoration:underline}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xs": "667.98",
	"sm": "947.98",
	"md": "1023.98",
	"lg": "1229.98",
	"container": "dbRt1ZWP",
	"feedback": "KJDcWObs",
	"content": "X+Sne2rY",
	"row": "VRde5Dvm",
	"rowToBottom": "aYJDWYUO",
	"col": "w1bQs93X",
	"colBetween": "lyB5SPJI",
	"logos": "_0wBQ9mul",
	"logo": "Ics47I-e",
	"nav": "_6yqagzpl",
	"navLink": "k7DyR+Vu",
	"socials": "wDBtmJng",
	"social": "JbxNUNsa",
	"copy": "BZD14xKs",
	"link": "AwhTQl36"
};
module.exports = ___CSS_LOADER_EXPORT___;
